import { TitleBlockWrapper } from '@anm/components/TitleBlock';
import { flexColumn, media, UserFormRow } from '@anm/styles/helpers';
import styled from 'styled-components';

const firstSectionTablet = media.tablet`
  margin-top: 0;
`;

const UserSubscriptionWrapper = styled.div`
  ${flexColumn};
  margin: 0 auto;
  padding: 0 10px;
  align-items: center;
  max-width: 840px;
  > * {
    width: 100%;
    margin-top: 36px;
    &:first-child {
      margin-top: 40px;
      ${firstSectionTablet};
    }
  }
  ${TitleBlockWrapper} {
    margin-bottom: 16px;
  }
`;

export const UserSubscriptionFormRow = styled(UserFormRow)`
  align-items: flex-start;
  width: calc(100% + 20px);
  > * {
    align-self: stretch;
    display: flex;
    flex-direction: column;
    flex: 1 1 340px;
    margin: 10px;
  }
`;

export const BillingInfoBlockWrapper = styled.div`
  margin-bottom: 23px;
`;

export default UserSubscriptionWrapper;
